import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";
import central from "../../assets/pdf/3PL Central.pdf";
import club from "../../assets/pdf/24+Fit+Club.pdf";
import campaign from "../../assets/pdf/Active_Campaign.pdf";
import advologix from "../../assets/pdf/Advologix.pdf";
import concert from "../../assets/pdf/Concert_health.pdf";
import solution from "../../assets/pdf/At Home Solutions.pdf";
import dubai_blog1 from "../../assets/images/country/dubai_blog1.webp";
import dubai_blog2 from "../../assets/images/country/dubai_blog2.webp";
import dubai_blog3 from "../../assets/images/country/dubai_blog3.webp";

const Dubai = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Salesforce Consultant in Dubai | Implementation, Integration & CRM Experts – Codezix </title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta
                    name="description"
                    content="Looking for expert Salesforce consultants in Dubai? Codezix offers Salesforce implementation, customization, and integration services across all major clouds. Boost efficiency and transform your business today."
                />
                <meta
                    name="keywords"
                    content="salesforce consultant in Dubai , salesforce consulting in Dubai , salesforce consulting partner in Dubai , salesforce consultants in Dubai, salesforce developer in Dubai"
                />

                {/* 1) Organization + WebSite + WebPage */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://codezix.com/#organization",
      "url": "https://codezix.com",
      "name": "Codezix",
      "legalName": "Codezix Solutions",
      "logo": {
        "@type": "ImageObject",
        "url": "https://codezix.com/assets/images/logo.webp",
        "width": 250,
        "height": 80
      },
      "image": "https://codezix.com/assets/images/logo.webp",
      "description": "Codezix is a global Salesforce, cloud consulting, and custom application development company helping organizations innovate faster.",
      "email": "info@codezix.com",
      "telephone": "+1-917-730-7436",
      "sameAs": [
        "https://www.linkedin.com/company/codezix",
        "https://www.facebook.com/codezix",
        "https://twitter.com/codezix"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://codezix.com/#website",
      "url": "https://codezix.com",
      "name": "Codezix",
      "publisher": {
        "@id": "https://codezix.com/#organization"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://www.codezix.com/salesforce/development-company-in-dubai#webpage",
      "url": "https://www.codezix.com/salesforce/development-company-in-dubai",
      "inLanguage": "en-US",
      "name": "Salesforce Consultant in Dubai | Implementation, Integration & CRM Experts – Codezix",
      "isPartOf": {
        "@id": "https://codezix.com/#website"
      },
      "description": "Expert Salesforce consulting, implementation, customization, and integration services in Dubai by Codezix, helping businesses streamline operations and maximize CRM potential."
    }
  ]
}
    `}
                </script>

                {/* 2) Service schema */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development-company-in-dubai#service",
  "name": "Salesforce Consulting & Implementation Services in Dubai",
  "serviceType": "Salesforce Consulting, Implementation & Integration",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization",
    "name": "Codezix"
  },
  "description": "Codezix offers Salesforce consulting, implementation, customization, integration, and ongoing CRM support services for businesses in Dubai.",
  "url": "https://www.codezix.com/salesforce/development-company-in-dubai",
  "areaServed": {
    "@type": "City",
    "name": "Dubai"
  }
}
    `}
                </script>

                {/* 3) FAQPage schema */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What Salesforce consulting services does Codezix offer in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "At Codezix, we handle the full Salesforce consulting lifecycle in Dubai, including CRM setup, customization, integration with existing systems, data migration, and post-implementation support."
      }
    },
    {
      "@type": "Question",
      "name": "How can I hire a Salesforce consultant from Codezix in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact us through our website or email. Our team will understand your Dubai business requirements and propose a tailored Salesforce consulting and implementation plan."
      }
    },
    {
      "@type": "Question",
      "name": "Does Codezix provide Salesforce cloud solutions in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Codezix works with Salesforce Sales Cloud, Service Cloud, Marketing Cloud and also builds custom Salesforce applications for businesses in Dubai."
      }
    },
    {
      "@type": "Question",
      "name": "How experienced is Codezix in Salesforce projects in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Codezix has a team of more than 30 certified Salesforce professionals and has successfully delivered over 50 Salesforce projects globally, including implementations for clients in Dubai."
      }
    },
    {
      "@type": "Question",
      "name": "Can Codezix integrate Salesforce with other business applications in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we integrate Salesforce with ERPs, e-commerce platforms, analytics tools, and other core business systems to create a connected ecosystem for Dubai-based organizations."
      }
    },
    {
      "@type": "Question",
      "name": "Does Codezix offer Salesforce automation and AI solutions in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Codezix uses Salesforce automation and AI capabilities to help Dubai businesses improve efficiency, enhance customer experiences, and make better data-driven decisions."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to implement Salesforce consulting in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Timelines depend on the scope and complexity. Basic Salesforce implementations in Dubai can go live in a few weeks, while large and highly customized projects may take several months."
      }
    },
    {
      "@type": "Question",
      "name": "Why choose Codezix for Salesforce consulting in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Codezix combines certified Salesforce expertise, global project experience, and a strong understanding of Dubai businesses to deliver scalable, practical CRM solutions that grow with your organization."
      }
    }
  ]
}
    `}
                </script>

                {/* 4) Postal address – separate block (Dubai office) */}
                {/* <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "PostalAddress",
  "streetAddress": "6th Floor, Meydan Grandstand, Meydan Road, Nad Al Sheba",
  "addressLocality": "Dubai",
  "addressRegion": "UAE",
  "postalCode": "00000",
  "addressCountry": "AE",
  "telephone": "+1-917-730-7436"
}
    `}
                </script> */}
            </Helmet>



            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Dubai</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/dubai.webp')} alt="Salesforce consulting Dubai" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className='explore-heading text-left'>
                                <h2>Looking for a Salesforce consultant in Dubai you can actually rely on? That’s us—Codezix</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">Dubai’s booming, and if you want to keep up, you need a CRM system that doesn’t just sit there but actually pushes your business forward. That’s what we do. We help you squeeze every bit of value out of Salesforce. From the first conversation right through to ongoing tweaks, we’re with you.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                Here’s how we work: We don’t force you to fit some canned solution. We get to know your business, then shape{' '}
                                <a
                                    href="https://www.codezix.com/salesforce/consulting"
                                    rel="noopener noreferrer"
                                >
                                    Salesforce around what you really need.
                                </a>
                                Starting fresh? Upgrading what you’ve got? Our certified team dives in, making things straightforward and focused on real results. We’re all about flexible, future-proof setups that make your team’s day easier and keep your business ready for what’s next.
                            </p>

                            <p className="prose-lg wow fadeUp">We cover everything Salesforce offers—Sales Cloud, Service Cloud, Marketing Cloud, Experience Cloud. Need custom integrations or automation? We’ve got it handled. Doesn’t matter if you’re running a startup or managing a huge operation. We stick to data-driven solutions that actually move the needle: happier customers, stronger sales, a better CRM across the board.
                            </p>
                            <p className="prose-lg wow fadeUp">Choose the right Salesforce partner and you don’t just get software—you change how your business works. We bring industry know-how and technical skill, so you can make smarter moves, use best practices, and really take advantage of everything Salesforce can do.
                            </p>
                            <p className="prose-lg wow fadeUp">And we’re not the type to disappear after launch. Codezix sticks around. Training, support, updates—we make sure your CRM keeps up as your business grows and changes.
                            </p>

                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Our Salesforce Services in Dubai</h2>
                                <p className="prose-lg">
                                    Looking for Salesforce consulting in Dubai that actually fits your business? Codezix is here for you. We don’t just deliver cookie-cutter CRM systems—we build end-to-end Salesforce solutions designed to help your company grow faster and work smarter.
                                </p>
                                <p className="prose-lg">Our certified Salesforce consultants know the Dubai market inside and out. We’ve helped businesses across all kinds of industries modernize how they work, automate the boring stuff, and build smarter, customer-focused systems that really make a difference.</p>
                                <p className="prose-lg">Dubai moves fast. You need digital tools that keep up. Our team brings years of hands-on experience, so we get the pressures and opportunities you face here. We work side by side with you—no one-size-fits-all plans, just real conversations and strategies built around your goals.
                                </p>
                                <p className="prose-lg">We handle everything. CRM set-up, cloud integration, customizations, and ongoing support. But we don’t stop at the tech. We care about what happens after launch: making sure your team actually uses the system, your data stays clean, and your Salesforce setup keeps your customers happy and your operations running smoothly.
                                </p>
                                <p className="prose-lg">Codezix leads the way in Salesforce consulting in Dubai. We help you cut down on manual tasks, boost efficiency, and set your business up for long-term success.
                                </p>
                                <p className="prose-lg">Want to see how the right Salesforce strategy can change the way you work? Reach out to our Account Executives. Let’s talk about what’s possible for your business.
                                </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting in Dubai</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our Salesforce consulting team in Dubai helps businesses overcome CRM challenges such as low productivity, process misalignment, and poor data management. We analyze your workflows and create actionable strategies to optimize your Salesforce environment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Elevate your business with our expert implementation services. Our certified professionals
                                                specialize in setting up, customizing, and configuring cloud-based solutions and add-ons,
                                                helping you drive innovation, streamline operations, and accelerate growth with technology
                                                tailored to your unique business needs
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We tailor Salesforce to match your specific processes — from lead tracking to reporting automation. With our Salesforce customization services, you’ll have a CRM that truly fits your business.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='CRM solutions Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We develop robust, scalable, and user-friendly Salesforce apps customized to your business. Whether you need custom dashboards, AI automation, or mobile apps — our developers deliver innovative solutions using Lightning, LWC, and Apex.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Boost efficiency and collaboration by connecting Salesforce with ERP, CMS, accounting, or third-party platforms. Our Salesforce integration services in Dubai enable real-time data exchange and improved operational visibility.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Migrate safely from legacy systems to Salesforce with zero data loss. Codezix ensures complete data accuracy, testing, and post-migration validation for a smooth transition
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support & Maintenance</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our job doesn’t end at implementation. We offer 24/7 Salesforce support and maintenance across all time zones, ensuring your CRM runs smoothly with proactive monitoring and issue resolution.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Our Certified Salesforce Consulting Team in Dubai</h2>
                                <p className="prose-lg">Meet our certified Salesforce consultants in Dubai. We know the ins and outs of the industry, and we bring that experience to every project we tackle. Whether you’re a small startup or a big enterprise, we’ll help you design and roll out CRM solutions that actually boost performance, keep your customers coming back, and drive real returns.</p>
                                <p className="prose-lg">Yes, we work with clients all over the world. But when it comes to Dubai, we don’t just copy-paste a generic plan. We get what makes this market tick, and we tailor every project to fit local needs.</p>
                                <p className="prose-lg">At the end of the day, you want a partner who understands your challenges and can build a strategy that grows with you. That’s what we do.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions dubai' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting dubai' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Consultants in Dubai – Experts Across All Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Looking for Salesforce experts in Dubai? You’ve come to the right place. Our team knows Sales Cloud, Service Cloud, Marketing Cloud, and Experience Cloud inside and out. We don’t just set things up — we tailor every solution to fit your business and what you’re aiming for. Whether you want to streamline your processes, boost communication, or actually use your data to make decisions, we’re on it.
                                </p>
                                <p className="wow fadeUp prose-lg text-left">
                                    We handle everything from deep-dive analytics to smart workflow automation, making sure Salesforce really works for you. Plus, since we understand how things work in Dubai, we blend local know-how with serious technical chops. The result? You get more out of your Salesforce investment, every single day.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve – Skilled Salesforce Developers in Dubai</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Our Salesforce developers in Dubai know how to build CRM solutions that actually fit your industry—retail, healthcare, finance, manufacturing, logistics, you name it. Need a custom app? Want smarter automation or seamless third-party integrations? We make sure your Salesforce setup works exactly the way your business needs.
                                </p>
                                <p className="wow fadeUp prose-lg text-left">
                                    We help you tighten up your sales process, deliver better customer service, and boost your marketing results. With our team in Dubai, you don’t just get a Salesforce system—you get real solutions that move the needle and set you up for long-term success.
                                </p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation Dubai" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions Dubai" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts Dubai" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner Dubai" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting Dubai" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation Dubai" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions Dubai" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix as Your Salesforce Partner in Dubai</h2>
                                <p className="prose-lg">Our team of skilled Salesforce developers in Dubai provides tailored solutions to a wide range of industries, including retail, healthcare, finance, manufacturing, and more. We help businesses optimize their Salesforce platforms to improve efficiency, enhance customer relationships, and drive growth. With extensive experience in developing customized Salesforce applications, our Salesforce developers in Dubai ensure that your systems align perfectly with your specific industry requirements. Whether it’s automating sales processes, streamlining customer service, or improving marketing campaigns, we deliver powerful solutions that bring measurable value and long-term success to your organization.</p>
                            </div>
                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Consultants </li>
                                            <li className="wow fadeUp prose-lg">80+ expert developers with 300+ salesforce certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business and 90% client retention rate.</li>
                                            <li className="wow fadeUp prose-lg">Ensures quality, security, and timely delivery.</li>
                                            <li className="wow fadeUp prose-lg">10+ years delivering CRM success stories across industries.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Ongoing Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 Salesforce maintenance & optimization services.</li>
                                            <li className="wow fadeUp prose-lg">100% in-house code development for superior quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery for seamless execution</li>
                                            <li className="wow fadeUp prose-lg">Rigorous testing ensures reliable and efficient Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className="service-section-right">
                                            <h3 className="wow fadeUp">3 PL Central</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A <strong>U.S.-based warehouse</strong> management leader, optimized operations using Salesforce automation developed by Codezix.{" "}
                                                <a
                                                    href={central}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>

                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club (UK) </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Empowered their fitness community with <strong> data-driven marketing</strong> through Salesforce Marketing Cloud.
                                                <a
                                                    href={club}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a leading CRM solution, providing a powerful enterprise application compatible across multiple devices. With a robust app marketplace, it strengthens marketing and sales alignment, driving better leads and high-quality pipelines.
                                                <a
                                                    href={campaign}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix (USA)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Simplified legal case management with Salesforce customization and workflow automation.
                                                <a
                                                    href={advologix}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health (USA)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Integrated Salesforce Health Cloud for real-time patient engagement.
                                                <a
                                                    href={concert}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce consulting Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions (Dubai)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Enhanced healthcare service delivery using a unified Salesforce Service Cloud system.
                                                <a
                                                    href={solution}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Recent Salesforce Insights</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={dubai_blog1} alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">The Future of Salesforce Consulting in Dubai: Trends to Watch in 2025 </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Dubai’s business scene moves fast, and Salesforce is right at the center of this change. Every industry—retail, real estate, logistics, you name it—is looking to Salesforce consulting in Dubai to connect better with customers, automate what used to be manual, and grow revenue.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={dubai_blog2} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Transforming Dubai’s Financial Services with Salesforce CRM</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Dubai’s financial scene moves fast. Salesforce consulting is right at the heart of that change. More banks and investment firms are jumping into digital innovation, so the need for skilled Salesforce consultants in Dubai just keeps growing. With Salesforce CRM, businesses deliver more personal service, run smoother operations, and keep up with all those tough regulations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={dubai_blog3} alt='CRM solutions Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                How Salesforce Is Changing Real Estate in Dubai
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce Consulting in Dubai is transforming how real estate companies operate by streamlining sales, managing client data, and automating workflows. In a fast-paced market like Dubai, having the right Salesforce consulting partner ensures better efficiency and growth
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ============ FAQ – DUBAI VERSION ============ */}
                            <section className="py-5 bg-light w-100">
                                <div className="py-4">

                                    <div className="accordion w-100" id="faqAccDubai">

                                        {/* Q1 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub1"
                                                >
                                                    What Salesforce consulting services does Codezix offer in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub1"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    At Codezix, we handle everything when it comes to Salesforce consulting in Dubai.
                                                    Think CRM setup, customization to fit your business, linking Salesforce with your
                                                    existing systems, moving your data over, and sticking around for support after
                                                    everything’s up and running.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q2 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub2"
                                                >
                                                    How can I hire a Salesforce consultant from Codezix in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub2"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    Just reach out through our website or shoot us an email. We’ll take the time to
                                                    learn what your business needs, then put together a Salesforce plan that actually
                                                    makes sense for you.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q3 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub3"
                                                >
                                                    Does Codezix provide Salesforce cloud solutions in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub3"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    We do. Our team works with Sales Cloud, Service Cloud, Marketing Cloud, and even
                                                    builds custom Salesforce apps for businesses in Dubai.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q4 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub4"
                                                >
                                                    How experienced is Codezix in Salesforce projects in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub4"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    You’re in good hands. We’ve got over 30 certified Salesforce pros on our Dubai team
                                                    and we’ve finished more than 50 Salesforce projects around the world, Dubai included.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q5 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub5"
                                                >
                                                    Can Codezix integrate Salesforce with other business applications in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub5"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    No problem. We connect Salesforce to ERPs, e-commerce platforms, analytics tools —
                                                    you name it — to help your business run smoother.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q6 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub6"
                                                >
                                                    Does Codezix offer Salesforce automation and AI solutions in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub6"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    Yes, we use Salesforce’s automation and AI to help Dubai businesses work smarter,
                                                    keep customers happy, and make decisions based on real data.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q7 */}
                                        <div className="accordion-item border rounded-3 mb-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub7"
                                                >
                                                    How long does it take to implement Salesforce consulting in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub7"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    It depends on what you need. If it’s a basic setup, you could be up and running in
                                                    a few weeks. Bigger, more complex projects can take several months.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Q8 */}
                                        <div className="accordion-item border rounded-3 shadow-sm">
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button fs-3 fw-semibold collapsed text-start"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#faqDub8"
                                                >
                                                    Why choose Codezix for Salesforce consulting in Dubai?
                                                </button>
                                            </h2>
                                            <div
                                                id="faqDub8"
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#faqAccDubai"
                                            >
                                                <div className="accordion-body fs-3 text-muted text-start">
                                                    We mix certified know-how with real-world experience, and we tailor everything to
                                                    fit Dubai businesses. You get a Salesforce setup that actually works and grows with you.
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </section>


                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Dubai;